import { render, staticRenderFns } from "./ClassProgressTab.vue?vue&type=template&id=d2dbb3e6&scoped=true"
import script from "./ClassProgressTab.vue?vue&type=script&lang=js"
export * from "./ClassProgressTab.vue?vue&type=script&lang=js"
import style0 from "./ClassProgressTab.vue?vue&type=style&index=0&id=d2dbb3e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dbb3e6",
  null
  
)

export default component.exports